import React from "react";
import {withStyles} from "@material-ui/core";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader";
import Info from "components/Typography/Info";
import Button from "components/CustomButtons/Button.js";


import blogsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/blogsStyle.js";
import Success from "../../components/Typography/Success";
import Warning from "../../components/Typography/Warning";
import TrendingUp from "@material-ui/core/SvgIcon/SvgIcon";
import DoneIcon from '@material-ui/icons/Done';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import Primary from "../../components/Typography/Primary";
import CardAvatar from "../../components/Card/CardAvatar";
import CardBody from "../../components/Card/CardBody";
import Badge from "../../components/Badge/Badge";
import storage from "../../utils/storage";
import intl from 'react-intl-universal';



function isEmpty(object) {
	if (object === null || object === undefined) {
		return true;
	}

	return false;
}

class PlanItem extends React.Component {


	constructor(props, context) {
		super(props, context);
		this.state = {
			userLogin: false,
			avatarPadding: '5%'
		};

		if (!isEmpty(storage.get('token'))) {
			this.state.userLogin = true;
		} else {

		}

		if (this.props.data.planItem === '3') {
			this.state.avatarPadding = '0'
		}

	}

	render() {
		const {classes} = this.props;
		const data = this.props.data;


		return (
			<GridItem xs={12} sm={6} md={6} lg={4} style={{marginTop: '24px'}}>
				<Card
					pricing
					// background
					// style={{backgroundImage: `url(${cardBlog3})`}}
				>
					<CardBody pricing background>
						<CardAvatar profile style={{
							backgroundColor: 'rgba(44,83,100,0.05)',
							padding: `${this.state.avatarPadding}`
						}}>
							<img
								src={data.imageLogoUrl}
								alt="..."/>
						</CardAvatar>
						<h1 className={classes.cardTitleWhite}>
							<small>¥
								{
									data.priceFree !== data.price ?
										<span>
										<s
											style={{color: '#c31432'}}>{data.priceFree}</s>
											&nbsp;&nbsp;
										</span>
										:
										null
								}

							</small>

							{data.price}
						</h1>

						<h2>
							{data.title}
						</h2>
						<ul>
							<li>
								{(() => {
										switch (data.planItem) {
											case "1":
												return (
													<div>
														{
															data.seriesFinish ?
																<Badge color="success">
																	<span
																		style={{fontSize: '10pt'}}>
																		{intl.get('finish_2')}
																	</span>
																</Badge>
																:
																<Badge color="warning">
																	<span
																		style={{fontSize: '10pt'}}>
																		{intl.get('marking')}
																	</span>
																</Badge>
														}
													</div>
												);
												break;
											case "2":
												return (
													<div>
														{
															data.recommend ?
																<Badge color="rose">
																	<span
																		style={{fontSize: '10pt'}}>
																		{intl.get('recommend')}
																	</span>
																</Badge>
																:
																null
														}
														{
															(data.discount !== null) ?

																<Badge color="info">
																	<span
																		style={{fontSize: '10pt'}}>{data.discount}
																	</span>
																</Badge> :
																null
														}
													</div>
												);
												break;
											case "3":
												break;
											default:
												return null;
										}
									}
								)()}

							</li>
							<li>
								<b style={{color: '#000'}}>
									{data.textShowInfo}
								</b>
							</li>
						</ul>
						{
							this.state.userLogin ?
								<span>{(() => {
									switch (data.planItem) {
										case "1":
											return (
												<span>
												{
													data.userHave ?

														<Button color="primary" round disabled>
															<span>{intl.get('owned')}</span>
														</Button> :
														<Button color="rose" round
																href={'/create_pay/' + data.planId}>
															<span>{intl.get('subscription_series')}</span>
														</Button>

												}
												</span>
											);
										case "2":
											return (
												<span>
												{
													data.userHave ?

														<Button color="primary" round disabled>
															<span>{intl.get('owned')}</span>
														</Button> :
														<Button color="rose" round
																href={'/create_pay/' + data.planId}>
															{intl.get('subscription_bundle')}
														</Button>
												}
												</span>

											);
										case "3":
											return (
												<span>
												{
													data.userHave ?

														<Button color="primary" round disabled>
															<span>{intl.get('owned')}</span>
														</Button> :
														<Button color="rose" round
																href={'/create_pay/' + data.planId}>
															{intl.get('subscription_other')}
														</Button>
												}
												</span>
											);
										default:
											return null
									}
								})()}</span> :
								<span>{(() => {
									switch (data.planItem) {
										case "1":
											return (
												<Button color="rose" round href={'/login'}>
													{intl.get('subscription_series_login')}
												</Button>
											);
										case "2":
											return (
												<Button color="rose" round href={'/login'}>
													{intl.get('subscription_bundle_login')}
												</Button>
											);
										case "3":
											return (
												<Button color="rose" round href={'/login'}>
													{intl.get('subscription_other_login')}
												</Button>
											);
										default:
											return null
									}
								})()}</span>
						}

					</CardBody>
				</Card>
			</GridItem>
		);
	}
}

export default withStyles(blogsStyle)(PlanItem)